import * as API from "middleware/api";

export const echeqRuleCreatePreMiddleware = () => API.executeWithAccessToken("manage.echeq.rules.pre");
export const echeqRuleCreatePreViewMiddleware = (valuesForm) =>
    API.executeWithAccessToken("manage.echeq.rules.preview", valuesForm);
export const echeqRuleCreateSendMiddleware = (valuesForm) =>
    API.executeWithAccessToken("manage.echeq.rules", valuesForm);
export const downloadErrorsEcheqRules = (fileFormat, numberRule) =>
    API.executeWithAccessToken("/echeqRules.exportErrors", {
        format: fileFormat,
        numberRule,
    });
